import { render, staticRenderFns } from "./ParallaxAd.vue?vue&type=template&id=d333057e"
import script from "./ParallaxAd.vue?vue&type=script&lang=js"
export * from "./ParallaxAd.vue?vue&type=script&lang=js"
import style0 from "./ParallaxAd.vue?vue&type=style&index=0&id=d333057e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports